<template>
  <b-form action="#">
    <b-form-group
      label-cols="12"
      label-cols-sm="12"
      label-cols-lg="12"
      label-for="declinedReason"
      :label="`${$t('compliant_form.reason_description')}:`"
    >
      <b-input-group>
        <b-form-textarea
          id="declinedReason"
          :maxlength="1000"
          v-model="declinedReason"
          rows="4"
          @keyup="$emit('declineReason', declinedReason)"
        ></b-form-textarea>
      </b-input-group>
    </b-form-group>
  </b-form>
</template>
<script>
export default {
  data() {
    return {
      declinedReason: null,
    };
  },
};
</script>
